import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import {  MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { AppMainService } from "src/app/app-main.service";
import { SOChannel, SoStageId } from "src/app/inventory/sales-order/constants/constants";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { InvoiceStatus, SalesOrderStatus, Severity } from "src/app/inventory/constants/constants";
import { ReceivePaymentDialogType } from "../receive-payments/constants/constants";
import { Subject, takeUntil } from "rxjs";
import { ImportserialService } from "../../services/importserial.service";

@Component({
    selector: "app-applied-amount-view-modal",
    templateUrl: "./applied-amount-view-modal.component.html",
    styleUrls: ["./applied-amount-view-modal.component.scss"],
})
export class AppliedAmountViewModalComponent implements OnInit, OnChanges, OnDestroy {
    @Input() id;
    @Input() channelName;
    @Input() displayAppliedAmountViewModal;
    @Input() creditMemo;
    @Input() invoiceDetails;
    @Input() soDetails;
    @Output() onClose = new EventEmitter();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    soChannel = SOChannel;
    soStatus = SalesOrderStatus;
    transactions = [];
    receivedPaymentId;
    displayInvoiceReceive = false;
    receivePaymentDialogType = "";
    invStatus = InvoiceStatus;
    soStage = SoStageId;

    /** Credit Memo */
    netAppliedAmount = 0;
    displayCreditSelect = false;

    /** Write check */
    checkId = 0;
    checkDialogType = "VIEW";
    displayWriteCheck = false;

    // fraction digits
    fractionDigits: number = 0;

    constructor(
        public app: AppMainComponent,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService,
        private importService: ImportserialService
    ) {}

    ngOnInit() {
        this.getFractionDigits();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.channelName && changes.channelName.currentValue) {
            this.channelName = changes.channelName.currentValue;
            if(this.channelName == SOChannel.SALES_ORDER){
                this.getSalesOrderTransactions();
            } else if(this.channelName == SOChannel.INVOICING){
                this.getInvoiceTransactions();
            } else if(this.channelName == SOChannel.CREDIT_MEMO){
                this.getCreditMemoTransactions();
            }
        }
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    getSalesOrderTransactions(){
        this.transactions = [];
        this.appMainService.isShowSpinner("loadTransactions");
        this.salesOrderService
            .getSalesOrderReceivedPaymentById(this.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.transactions = res;
                    this.appMainService.isHideSpinner("loadTransactions");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadTransactions");
                    this.showErrorMessage();
                }
            });
    }
    getInvoiceTransactions(){
        this.transactions = [];
        this.appMainService.isShowSpinner("loadTransactions");
        this.salesOrderService
            .getInvoiceReceivedPaymentById(this.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.transactions = res;
                    this.appMainService.isHideSpinner("loadTransactions");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadTransactions");
                    this.showErrorMessage();
                }
            });
    }
    getCreditMemoTransactions(){
        this.transactions = [];
        this.appMainService.isShowSpinner("loadTransactions");
        this.salesOrderService
            .getCreditMemoTransactionsById(this.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.transactions = res;
                    this.netAppliedAmount = res?.reduce((total, trx) => total + Number(trx.creditAmount), 0);
                    this.appMainService.isHideSpinner("loadTransactions");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadTransactions");
                    this.showErrorMessage();
                }
            });
    }

    onRPNumberViewClick(e){
        if(this.channelName == SOChannel.CREDIT_MEMO){
            if(e?.transactionTypeName?.toLowerCase() == 'check'){
                this.showWriteCheckDialog(e);
            } else {
                this.showReceivePaymentDialog(e);
            }
        } else if(this.channelName == SOChannel.INVOICING){
            if(this.invoiceDetails?.invoiceStatusId == this.invStatus.Processing){
                this.showCreditMemoDialog(e);
            } else {
                this.showReceivePaymentDialog(e);
            }
        } else if(this.channelName == SOChannel.SALES_ORDER){
            if(this.soDetails?.salesOrderStageId != this.soStage.Shipped){
                this.showCreditMemoDialog(e);
            } else {
                this.showReceivePaymentDialog(e);
            }
        } else {
            this.showReceivePaymentDialog(e);
        }
    }

    /** Received Payment */
    showReceivePaymentDialog(e){
        this.receivedPaymentId = e?.receivedPaymentId ?? 0;
        this.displayInvoiceReceive = true;
        this.receivePaymentDialogType = ReceivePaymentDialogType.ViewPaymentDetails;
    }
    onReceivePaymentsDialogClose(event) {
        this.displayInvoiceReceive = false;
    }
    /** End Received Payment */

    showCreditMemoDialog(e){
        this.receivedPaymentId = e?.receivedPaymentId ?? 0;
        this.displayCreditSelect = true;
    }
    onCreditMemoDialogClose(){
        this.receivedPaymentId = 0;
        this.displayCreditSelect = false;
    }


    /** Write Check */
    showWriteCheckDialog(e){
        this.checkId = e?.id;
        this.checkDialogType = "VIEW";
        this.displayWriteCheck = true;
    }
    onCloseWriteCheckDialog(){
        this.checkDialogType = "";
        this.displayWriteCheck = false;
    }
    /** End Write Check */


    onCloseDialog(){
        this.onClose.emit({});
    }
    showErrorMessage(){
        this.messageService.add({
            severity: Severity.Error,
            summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Error occurred ...",
        });
    }
}